<script setup lang="ts">
  import { useDjangoAuthStore } from '@/stores/authDjango'

  const authStore = useDjangoAuthStore()
  const giPointStore = useGIPointsStore()
  const { user } = storeToRefs(authStore)
  const { items: giPoints } = storeToRefs(giPointStore)
</script>
<template>
  <div class="top-left-box" v-if="user && !giPoints.length">
    <p class="mb-2">Welcome to the GEOProfile application, {{ user.first_name }}!</p>
    <p>
      To get started with your project, please go to "GI Data" to upload your ground investigation
      points.
    </p>
  </div>
</template>

<style scoped>
  .top-left-box {
    position: absolute;
    border-radius: 5px;
    width: 30%;
    top: 5%;
    left: 5%;
    z-index: 1000;
    background-color: white;
    padding: 10px;
    border: 1px solid #ccc;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  }
</style>
